export function scrollGridItem(
  minWidth: number,
  mobileMaxWidth?: number
): { minWidth: number; maxWidth: { xs: number; md: string } | string; flex: string } {
  return {
    minWidth: minWidth,
    maxWidth: mobileMaxWidth ? { xs: mobileMaxWidth, md: "none" } : "none",
    flex: "0 0 auto",
  };
}

export const scrollGridContainer = { width: "100%", minWidth: { xs: "max-content", sm: null } };

export const scrollContainer = {
  overflowX: "auto",
  overflowY: "hidden",
  display: "flex",
  width: "100%",
  flexWrap: "nowrap",
  scrollbarWidth: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
};
